(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/challenge/assets/javascripts/local-storage-middleware.js') >= 0) return;  svs.modules.push('/modules/challenge/assets/javascripts/local-storage-middleware.js');
'use strict';

function hasAnyMarked(coupon) {
  for (let eventIndex = 1; eventIndex < coupon.drawEvents.length; ++eventIndex) {
    for (let outcomeIndex = 1; outcomeIndex < coupon.drawEvents[eventIndex].length; ++outcomeIndex) {
      if ((outcomeIndex === 1 || outcomeIndex === 2 || outcomeIndex === 4) && coupon.drawEvents[eventIndex][outcomeIndex] === true) {
        return true;
      }
    }
  }
  return false;
}
function hasDifferentRowPrice(coupon) {
  const defaultRowPrice = parseFloat(svs.challenge.helpers.getDrawFromCoupon(coupon).rowPrice);
  const selectedRowPrice = parseFloat(coupon.chosenBetPrice);
  if (defaultRowPrice !== selectedRowPrice) {
    return true;
  }
  return false;
}
function getBoardData(coupon) {
  const data = [];
  coupon.drawEvents.forEach((drawEvent, index) => {
    if (index > 0) {
      let eventData = '';
      drawEvent.forEach((outcome, index) => {
        if (index === 1 && outcome === true) {
          eventData += '1';
        }
        if (index === 2 && outcome === true) {
          eventData += 'X';
        }
        if (index === 4 && outcome === true) {
          eventData += '2';
        }
      });
      data.push(eventData);
    }
  });
  return data;
}
svs.challenge.middleware.localStorageMiddleware = store => next => action => {
  next(action);

  const interestingActions = [svs.challenge.actions.SELECT_ALTERNATIVE, svs.challenge.actions.CLEAR_COUPON, svs.challenge.actions.SELECT_BET_AMOUNT, svs.challenge.actions.FETCH_XPERTEN_SUCCESS];
  if (interestingActions.indexOf(action.type) === -1) {
    return;
  }
  const lsData = store.getState().coupons.reduce((newLocalStorageData, coupon) => {
    if (hasAnyMarked(coupon) || hasDifferentRowPrice(coupon)) {
      newLocalStorageData[coupon.drawNumber] = {
        baseRow: coupon.baseRow,
        boardData: getBoardData(coupon),
        hasActionbar: coupon.hasActionbar,
        selectedRowPrice: coupon.chosenBetPrice,
        xperten: coupon.xperten,
        xpertenMode: coupon.xpertenMode
      };
    }
    return newLocalStorageData;
  }, {});
  svs.components.Storage.browser.set(svs.challenge.constants.LOCAL_STORAGE_NAME, svs.challenge.constants.LOCAL_STORAGE_DOMAIN, lsData, svs.components.Storage.constants.EXPIRES_1WEEK);
};

 })(window);